/* Package JSON Import will be here */
import React from "react";
import { Helmet } from "react-helmet";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getCurrentPageTitle } from "utilities/utils";
/* Project Import will be here */

const DocumentPageTitle = (props) => {
    return (
        /* Set page title */
        <Helmet><title>{getCurrentPageTitle(props.location.pathname)}</title></Helmet>
    );
};

export default DocumentPageTitle;